import { createRootRouteWithContext } from "@tanstack/react-router";

import { QueryClient } from "@tanstack/react-query";
import BoundaryFallback from "../components/error-fallback/BoundaryFallback";
import NoPageFound from "../pages/app/no-page-found/NoPageFound";
import { TAuthStoreState } from "../store";
import RootComponent from "./root.lazy";

type TRouterContext = {
  auth: TAuthStoreState | null;
  queryClient: QueryClient;
};

export const rootRoute = createRootRouteWithContext<TRouterContext>()({
  component: RootComponent,
  notFoundComponent: () => <NoPageFound />,
  errorComponent: () => <BoundaryFallback />,
});
